export const instrumentationSchema = {
  scenario: [{
    name: 'inlineChart',
    value: 'inlineChart',
    setting: {},
    activity: [
      {
        name: 'inlineChartFilter',
        value: 'inlineChartFilter',
      },
      {
        name: 'inlineChartAction',
        value: 'inlineChartAction',
      },
      {
        name: 'inlineChartError',
        value: 'inlineChartError',
      },
    ],
  }],
};
